import { confirmResetPassword, signIn } from "aws-amplify/auth";
import { useFormik } from "formik";
import { useWebRouter } from "~utils/next-router/use-web-router";
import {
	toast,
	UpdatePasswordV2FormValues,
	UpdatePasswordV2Schema,
	UpdatePasswordV2 as View,
} from "ui-components";

import { useAuthContext } from "~auth/contexts/auth";

export const UpdatePasswordV2 = () => {
	const router = useWebRouter();
	const { refreshSession } = useAuthContext();
	const form = useFormik<UpdatePasswordV2FormValues>({
		validateOnMount: true,
		initialValues: {
			code: "",
			password: "",
			retypedPassword: "",
		},
		validationSchema: UpdatePasswordV2Schema,
		validate(values) {
			return values.password === values.retypedPassword
				? {}
				: { retypedPassword: "Passwords do not match" };
		},
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					await confirmResetPassword({
						username: router._query.email!,
						confirmationCode: values.code,
						newPassword: values.password,
					});
					await signIn({
						username: router._query.email!,
						password: values.password,
					});
					await refreshSession();
				},
				{
					loading: "Updating password...",
					success: "Signing you in to your account...",
					error: (e) => {
						helpers.setSubmitting(false);
						return e.message ?? "Something went wrong!";
					},
				},
			);
		},
	});

	return <View form={form} />;
};
